import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppSearchCountComponent } from '@ukam/ui-kit/searchs/count/search-count.component';
import { SearchService } from '@ukam/core/services/search.service';

@Component({
    selector: 'app-search-title',
    templateUrl: './search-title.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [AppSearchCountComponent]
})
export class AppSearchTitleComponent {
    @Input({ required: true }) searchService!: SearchService<any>;
    @Input() title: string = '';
}
